import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import React from 'react'
import './index.scss'
import Popup from '@Components/Popups/Popup'
import { DuplicateDocument } from '@Entities/document/document-to-upload'
import { getStringDate } from '@App/helpers/get-string-date'
import { formatOverclaimDocumentStatus } from '@Entities/overclaim/overclaim-uploaded-document'

export interface DuplicateDocumentPopupProps {
    duplicateDocuments: DuplicateDocument[]
    onContinue: () => void
}

const DuplicateDocumentPopup = ({ duplicateDocuments, onContinue }: DuplicateDocumentPopupProps) => (
    <Popup onClose={onContinue} showClose>
        <ConfirmationPopup
            title="Duplicate Document"
            popupClassName="duplicate-document-popup"
            onConfirm={onContinue}
            confirmButtonText="Continue"
        >
            <div className="duplicate-document-popup-body">
                <p>The documents below have already been uploaded and will be used for this overclaim.</p>
                {duplicateDocuments.map((document) => (
                    <div key={document.name} className="duplicate-document">
                        <p>{document.name}</p>
                        <p>{`Original upload date: ${getStringDate(document.originalUploadedAt)}`}</p>
                        {document.originalDocumentStatus && (
                            <p>{`Document status: ${formatOverclaimDocumentStatus(document.originalDocumentStatus)}`}</p>
                        )}
                    </div>
                ))}
            </div>
        </ConfirmationPopup>
    </Popup>
)
export default DuplicateDocumentPopup
